import React from 'react';
import { ErrorFallbackProps } from '@funtech-int/rival-react';

import { Button } from '@/shared/components/Button/Button';
import { TextWeight, TextTag, TextSize, Theme } from '@/shared/components/Text';
import { Text } from '@/shared/components/Text/Text';
import { withResourceFreeError } from '@/shared/components/WithResourceFreeError/withResourceFreeError';

import { useI18n } from '../../hooks/useI18n';

import styles from './_MovieCardModalError.module.css';

function MovieCardModalErrorBase({ resetError }: ErrorFallbackProps) {
    const i18n = useI18n();

    return (
        <div className={styles.root}>
            <div className={styles.headline}>
                <Text
                    weight={TextWeight.Bold}
                    tag={TextTag.H1}
                    theme={Theme.Dark}
                    size={TextSize.TitlePage}
                >
                    {i18n('movie_card_modal_error__title')}
                </Text>
            </div>
            <Text
                className={styles.description}
                weight={TextWeight.Regular}
                size={TextSize.Subtitle}
            >
                {i18n('movie_card_modal_error__description')}
            </Text>
            <Button
                className={styles.button}
                onClick={resetError}
                size={52}
                variant="primary"
                theme="dark"
            >
                {i18n('movie_card_modal_error__refresh')}
            </Button>
        </div>
    );
}

export const MovieCardModalError = withResourceFreeError(MovieCardModalErrorBase);
